import SiteNav from "@/pages/home/components/SiteNav";
import Hero from "@/pages/home/components/Hero";
import HotRanking from "@/pages/home/components/HotRanking";
import NewsFeed from "@/pages/home/components/NewsFeed";
import Materials from "@/pages/home/components/Materials";
import TagEntries from "@/pages/home/components/TagEntries";
import FaqSection from "@/pages/home/components/FaqSection";
import FollowBox from "@/pages/home/components/FollowBox";
import SiteFooter from "@/pages/home/components/SiteFooter";

export default function Home() {
  return (
    <div className="min-h-screen w-full bg-background-50 font-sans text-foreground-900">
      <SiteNav />
      <main>
        <Hero />
        <HotRanking />
        <NewsFeed />
        <Materials />
        <TagEntries />
        <FaqSection />
        <FollowBox />
      </main>
      <SiteFooter />
    </div>
  );
}